import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { NavbarService } from '../../services/navbar.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnDestroy {

    title = 'app';
    subscriptions: Subscription[] = [];


    constructor(private router: Router, private navBarService: NavbarService) {
        this.subscriptions.push(
            router.events.subscribe(result => {
                if (result instanceof NavigationStart) {
                    this.navBarService.toggleSubject.next(false);
                }
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
